import { Outlet } from 'react-router'

const Unauthorized = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Unauthorized
